import React from "react";

const ContactModal = ({ isModalOpen, sendMail, onClose }) => {
  if (!isModalOpen) return null;

  return (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10,
      }}
    >
      <div
        className="modal-content"
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          textAlign: "center",
          position: "relative",
          width: "300px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "5px",
            marginTop: "15px",
          }}
        >
          <button
            style={{
              marginTop: "10px",
              padding: "8px",
              border: "none",
              background: "#07b1b0",
              color: "white",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => sendMail("COD")}
          >
            Refer to Compliance on Demand
          </button>

          <button
            style={{
              marginTop: "10px",
              padding: "8px",
              border: "none",
              background: "#07b1b0",
              color: "white",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => sendMail("MLNO")}
          >
            Refer to your MLNO
          </button>
        </div>

        {onClose && (
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "transparent",
              border: "none",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default ContactModal;
